import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, PawPrint } from 'lucide-react';
import { BRAND } from '../../data/mock';

export const StickyMobileCTA = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] p-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-teal-500 to-cyan-600 flex items-center justify-center flex-shrink-0">
          <PawPrint className="w-5 h-5 text-white" />
        </div>
        <Button
          asChild
          size="lg"
          className="flex-1 text-white font-bold shadow-lg shadow-orange-500/30"
          style={{ background: 'linear-gradient(135deg, #f97316 0%, #fb7185 100%)' }}
        >
          <a href={BRAND.quoteUrl} target="_blank" rel="noopener noreferrer">
            Get Your Free Quote
            <ArrowRight className="w-5 h-5 ml-2" />
          </a>
        </Button>
      </div>
    </div>
  );
};
